import apiClient from './apiClient';
import store from 'store';
import { LOGOUT_ACTION } from 'store/rootReducer';
import { refreshTimer } from 'store/sessionReducer';

export const setupInterceptors = () => {
    apiClient.interceptors.response.use(
        response => {
            const url = response.config.url || '';
            if (!url.startsWith('/api/session/') && url !== '/userinfo' && url !== 'userinfo') {
                store.dispatch(refreshTimer());
            }
            return response;
        },
        error => {
            if (error.response?.status === 401) {
                store.dispatch({ type: LOGOUT_ACTION });
            }
            return Promise.reject(error);
        }
    );
};
